import React from 'react';
import classNames from 'classnames/bind';

import styles from './cardFeedStyles';

const cx = classNames.bind(styles);

const CardFeed = ({ children, type = '', className = '' }) => {
  // Component logic goes here...

  return (
    <div className={cx('cardFeed', { secondary: type === 'secondary' }, className)}>{children}</div>
  );
};

export default CardFeed;
